import { useNavigate, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAutoFocus } from "@/hooks/useAutoFocus";

/**
 * Come si gioca — pagina informativa sempre consultabile (P0-3).
 * Solo regole di gioco, semplici e accessibili. La spiegazione dettagliata
 * dell'accessibilità (VoiceOver/TalkBack) è una pagina separata (fase P1-8).
 */
const RULES = [
  { t: "6 secondi", d: "Hai 6 secondi per ogni richiesta." },
  {
    t: "Rispondi con i tocchi",
    d: 'Rispondi TOCCANDO lo schermo il numero di volte richiesto. Esempio: "TOCCA 3 VOLTE" significa 3 tocchi.',
  },
  { t: "Non toccare", d: '"NON TOCCARE" significa 0 tocchi.' },
  {
    t: "Osserva e ricorda",
    d: "Alcune prove chiedono di OSSERVARE e RICORDARE ciò che è apparso (animali, colori, forme, numeri): una domanda successiva può riferirsi a una prova precedente.",
  },
  {
    t: "Attenzione ai trabocchetti",
    d: "Leggi o ascolta bene la richiesta prima di rispondere.",
  },
  { t: "Conto alla rovescia", d: "Prima di ogni partita c'è un conto alla rovescia 5 → VIA!" },
];

export default function HowToPlay() {
  const navigate = useNavigate();
  const headingRef = useAutoFocus();

  return (
    <main className="screen" data-testid="how-to-play-screen">
      <div className="screen__header">
        <button
          type="button"
          className="back-btn"
          data-testid="how-to-play-back-button"
          onClick={() => navigate("/")}
          aria-label="Torna alla schermata principale"
        >
          <ChevronLeft size={16} strokeWidth={2.5} aria-hidden="true" />
          Indietro
        </button>
        <h1 className="screen__title" tabIndex={-1} ref={headingRef}>
          Come si gioca
        </h1>
      </div>

      <ul className="howto" data-testid="how-to-play-rules">
        {RULES.map((r, i) => (
          <li className="howto__item" key={i} data-testid={`how-to-play-rule-${i}`}>
            <span className="howto__title">{r.t}</span>
            <span className="howto__desc">{r.d}</span>
          </li>
        ))}
      </ul>

      <p className="howto__note" data-testid="how-to-play-accessibility-note">
        Accessibilità: la voce può essere attivata dalle{" "}
        <Link to="/settings" className="howto__link" data-testid="how-to-play-settings-link">
          Impostazioni
        </Link>
        .
      </p>
    </main>
  );
}
